import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmOrganizationsRoute: InvariantJiraRoute = {
	name: 'products-jsm-organizations',
	path: '/jira/settings/products/servicedesk/organizations',
	exact: true,
};
